/* global __GDC_API__, __VERSION__, __COMMIT_HASH__, __VERSION_TAG__, __COMMIT_LINK__ */

import { fetch } from 'utils/ajax';
import { handleActions } from 'redux-actions';

let apiBaseUrl = `https://github.com/NCI-GDC/gdcapi`;

let red = 'color: rgb(173, 30, 30);';
let blue = 'color: rgb(89, 139, 214);';
let fontStyle = 'font-weight: bold;';

let logVersionInfo = ({
  uiVersionTag,
  uiCommitLink,
  apiCommit,
  apiVersion
}) => {
  // UI info
  console.groupCollapsed(
    `%c★ UI Git Info\n=============`,
    `${red};${fontStyle}`);

  console.info(
    `%cTag: %c${uiVersionTag}`,
    fontStyle, blue);

  console.info(
    `%cCommit Link: %c${uiCommitLink}`,
    fontStyle, blue);
  console.groupEnd();

  // API info
  console.groupCollapsed(
    `%c★ API Git Info\n==============`,
    `${red};${fontStyle}`);

  console.info(
    `%cTag: %c${apiBaseUrl}/releases/tag/${apiVersion}`,
    fontStyle, blue);

  console.info(
    `%cCommit Link: %c${apiBaseUrl}/commit/${apiCommit}`,
    fontStyle, blue);
  console.groupEnd();
};

// Action Types

export let VERSION_INFO_SUCCESS = 'gdc/VERSION_INFO_SUCCESS';

// Action Creator

export function fetchApiVersionInfo() {
  return async (dispatch, getState) => {
    let response = await fetch({
      url: `${__GDC_API__}/status`,
      headers: {
        'Content-Type': 'application/json',
      }
    });

    let { tag, commit } = await response.json();
    let state = getState();

    let apiVersionInfo = {
      apiVersion: tag,
      apiCommit: commit
    };

    logVersionInfo({
      ...state.versionInfo,
      ...apiVersionInfo,
    });

    dispatch({
      type: VERSION_INFO_SUCCESS,
      payload: apiVersionInfo
    });
  };
}

// Reducer

let initialState = {
  uiVersion: __VERSION__,
  uiVersionTag: __VERSION_TAG__,
  uiCommitHash: __COMMIT_HASH__,
  uiCommitLink: __COMMIT_LINK__,
  apiVersion: ``,
  apiCommit: ``
};

export default handleActions({
  [VERSION_INFO_SUCCESS]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
}, initialState);
